import { useAppDispatch, useAppSelector } from "../../store";
import { chatContact, setContact } from "../../store/slices/chat";

const usePatients = () => {
  const contact: string | null = useAppSelector(chatContact);
  const dispatch = useAppDispatch();

  const setCurrentContact = (contactId: string) => {
    dispatch(setContact({ id: contactId }));
  };

  return {
    contact,
    setCurrentContact
  };
};

export default usePatients;
